import React, { useState } from "react";
import QuantityControl from "./QuantityControl";
import { IAddToCartControlProps } from "@model/UIComponents.model";
import styles from "./UiLibraryComponent.module.css";

const AddToCartControl: React.FC<IAddToCartControlProps> = ({
  quantity,
  onQuantityChange,
  onClick,
  min = 1,
  max,
  disabled = false,
  loading = false,
  buttonText = "Add to Cart",
  infoText,
  step,
  customWrapperClass = "",
  quantityControlClass = "",
  buttonClass = "",
  infoTextClass = "",
  error,
  errorTextClass = "",
}) => {
  const [localError, setLocalError] = useState<string | null>(null);
  const effectiveError = error ?? localError;
  const isButtonDisabled = disabled || loading || !!effectiveError;

  const handleClick = () => {
    if (!isButtonDisabled) onClick(quantity);
  };

  return (
    <div className={`${styles.addCartWrapper} ${customWrapperClass}`} data-testid="add-to-cart-control">
      <QuantityControl
        value={quantity}
        onChange={onQuantityChange}
        min={min}
        max={max}
       step={step}   
       customContainerClass={quantityControlClass}
        onError={(msg) => setLocalError(msg)}
      />

      <button
        type="button"
        onClick={handleClick}
        className={`${styles.addCartButton} ${buttonClass}`}
        disabled={isButtonDisabled}
        data-testid="add-to-cart-button"
      >
        {loading ? "Adding..." : buttonText}
      </button>

      {infoText && (
        <div className={`${styles.addCartInfo} ${infoTextClass}`} data-testid="add-to-cart-info">
          {infoText}
        </div>
      )}

      {effectiveError && (
        <div className={`${styles.errorMessage} ${errorTextClass}`} data-testid="add-to-cart-error">
          {effectiveError}
        </div>
      )}
    </div>
  );
};

export default AddToCartControl;
